@if (job$ | async) {
  <div class="field grid col-12">
    <!--Page Title and Dashboard Link-->
    <div class="col-4">
      <h2>Service Provider Job Details</h2>
    </div>
    <div class="col-8">
      @if (!isNew) {
        <div class="flex justify-content-end gap-2 mt-3">
          @if (jobToUpdate && user$ | async; as user) {
            @if (isEditorOrAdmin(user, this.jobToUpdate.companyId || '')) {
              <button pButton
                class="h-2rem w-10rem"
                (click)="navigateToCsvImport()"
                icon="fa fa-file-csv"
                label="CSV Import">
              </button>
            }
          }
          <button pButton
            class="h-2rem w-10rem"
            (click)="republishWorkbook()"
            icon="fa fa-retweet fa-lg"
            label="Republish">
          </button>
          <button pButton
            class="h-2rem w-10rem"
            (click)="showManageFiles = true"
            icon="fa fa-file"
            label="Files">
          </button>
          <button pButton
            class="h-2rem w-10rem"
            (click)="navigateToWorkbook()"
            icon="fa fa-book"
            label="Workbook">
          </button>
          <button pButton
            class="h-2rem w-10rem"
            (click)="navigateToDashboard()"
            icon="far fa-chart-bar"
            label="Dashboard">
          </button>
        </div>
      }
    </div>
    <div class="field grid col-12">
      <label class="col-2">Job Number<i class="fa fa-lock ml-1 text-gray-500" pTooltip="Cannot be changed after creation"></i></label>
      <div class="col-10">
        <input type="text" pInputText placeholder="Enter Job Number" [(ngModel)]="jobToUpdate.name" [disabled]="!isNew" />
        @if (modelInvalid && !jobToUpdate.name) {
          <div>
            <label style="color:red; font-weight:bold;">Id is required!</label>
          </div>
        }
      </div>
    </div>
    <!-- Vendor Company -->
    @if (vendorCompanies$ | async; as vendorCompanies) {
      <div class="field grid col-12" >
        <label class="col-2">Service Provider (Vendor)</label>
        <div class="col-10">
          <span>
            {{ getVendorCompanyLabel(vendorCompanies) }}
          </span>
          @if (modelInvalid && invalidCompanyId) {
            <div>
              <label style="color:red; font-weight:bold;">User must belong to Service Provider</label>
            </div>
          }
        </div>
      </div>
    }
    <!-- Consumer Company -->
    @if (consumerCompanies$ | async; as consumerCompanies) {
      <div class="field grid col-12" >
        <label class="col-2">Operator (Consumer) <i class="fa fa-lock ml-1 text-gray-500" pTooltip="Cannot be changed after creation"></i></label>
        <div class="col-10">
          <p-select id="consumerCompaniesDropDown" [options]="consumerCompanies" optionLabel="label" optionValue="value" [(ngModel)]="jobToUpdate.consumerCompanyId" >
          </p-select>
          @if (modelInvalid && !jobToUpdate.consumerCompanyId) {
            <div>
              <label style="color:red; font-weight:bold;">Operator is required!</label>
            </div>
          }
        </div>
      </div>
    }
    <!-- Other Service Providers -->
    <div class="field grid col-12">
      <label class="col-2">OFS Shared With <i class="fa fa-lock ml-1 text-gray-500" pTooltip="Cannot be changed after creation"></i></label>
      <div class="col-10">
        @if (serviceProviderOptions$ | async; as serviceProviderOptions) {
          <p-multiSelect [options]="serviceProviderOptions"
          placeholder="Service Providers" [(ngModel)]="jobToUpdate.serviceProviderIds" [showClear]="true" ></p-multiSelect>
        }
      </div>
    </div>
    <!-- Well Name -->
    <div class="field grid col-12">
      <label class="col-2">Well Name</label>
      <div class="col-10">
        <input type="text" pInputText placeholder="Enter WellName" [(ngModel)]="jobToUpdate.wellInfo!.name"
          [disabled]="!isNew" />
          @if (modelInvalid && (!jobToUpdate.wellInfo!.name && !jobToUpdate.apiNumber)) {
            <div>
              <label style="color:red; font-weight:bold;">Well Name or Api Number is required!</label>
            </div>
          }
        </div>
      </div>
      <!-- Api Number -->
      <div class="field grid col-12">
        <label class="col-2">Api Number</label>
        <div class="col-10">
          <p-inputMask mask="99-999-99999" [(ngModel)]="jobToUpdate.apiNumber"
          placeholder="99-999-99999"></p-inputMask>
          @if (modelInvalid && (!jobToUpdate.wellInfo!.name && !jobToUpdate.apiNumber)) {
            <div>
              <label style="color:red; font-weight:bold;">Well Name or Api Number is required!</label>
            </div>
          }
        </div>
      </div>
      <!-- Job Type -->
      <div class="field grid col-12">
        <label class="col-2">Job Type<i class="fa fa-lock ml-1 text-gray-500" pTooltip="Cannot be changed after creation"></i></label>
        <div class="col-10">
          <p-select [options]="jobTypes" placeholder="Select Job Type" [(ngModel)]="jobToUpdate.workbookType"
          [disabled]="!isNew"></p-select>
          @if (modelInvalid && !jobToUpdate.workbookType) {
            <div>
              <label style="color:red; font-weight:bold;">Job Type is required!</label>
            </div>
          }
        </div>
      </div>
      <!-- Start & End Time -->
      <div class="field grid col-12">
        <label class="col-2">Arrive on Loc/Begin RU on Well</label>
        <div class="col-10">
          <p-date-picker [(ngModel)]="jobToUpdate.startTime" [showIcon]="true" [showTime]="true" [hourFormat]="'24'"
            yearRange="2018:2038">
          </p-date-picker>
          @if (modelInvalid && !jobToUpdate.startTime) {
            <div>
              <label style="color:red; font-weight:bold;">Start Time is required!</label>
            </div>
          }
        </div>
      </div>
      <div class="field grid col-12">
        <label class="col-2">Release from Loc/RD from Well </label>
        <div class="col-10">
          <p-date-picker [(ngModel)]="jobToUpdate.endTime" [showIcon]="true" [showTime]="true" [hourFormat]="'24'"
            yearRange="2018:2038">
          </p-date-picker>
          @if (jobToUpdate.endTime) {
            <i class="far fa-trash-alt clear-end-time" (click)="clearEndDate()"
            pTooltip="Clear Release from Loc/RD from Well Time"></i>
          }
        </div>
      </div>
      @if (canLinkJob(this.jobToUpdate)) {
        <!-- Job Linking -->
        @if (consumerCompanies$ | async; as consumerCompanies) {
          <div class="field grid col-12">
            @if (isNew) {
              <app-job-linker [job]="jobToUpdate" [companySelectItems]="consumerCompanies"
              ></app-job-linker>
            }
            @if (!isNew) {
              <app-job-linker [vendorJobId]="jobToUpdate.id || ''" [companySelectItems]="consumerCompanies"
              ></app-job-linker>
            }
          </div>
        }
      }
      <!-- DeviceList -->
      @if (jobToUpdate) {
        <div class="field grid col-12">
          <label class="col-2">Devices</label>
          <div class="col-10">
            <div class="flex align-items-center gap-2 flex-wrap">
              @for (device of getMappedDeviceList(jobToUpdate) | async; track device) {
                <p-chip
                  [label]="device.name"
                  [removable]="true"
                  (onRemove)="removeDevice(device.id || '')">
                </p-chip>
              }
              <button pButton
                type="button"
                class="p-button-sm"
                (click)="showDeviceDialog = true"
                pTooltip="Add Device">
                <i pButtonIcon class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
      }
      @if (jobToUpdate && user$ | async; as user) {
        @if (!isNew && isEditorOrAdmin(user, this.jobToUpdate.companyId || '')) {
          <div class="field grid col-12">
            <!-- Job Exports -->
            <div class="col-2">
              <label>Available Exports</label>
            </div>
            <div class="col-2">
              <button pButton (click)="downloadJobExport()"
                style="max-height:32px; width:100%; padding-top:3px; padding-bottom:5px;">
                <i pButtonIcon class="fa fa-download"></i>
                <span pButtonLabel>Job Data</span>
              </button>
            </div>
            <div class="col-2">
              <button pButton
                (click)="downloadJobSummaryExport()"
                style="max-height:32px; width:100%; padding-top:3px; padding-bottom:5px;">
                <i pButtonIcon class="fa fa-download"></i>
                <span pButtonLabel>Job Summary</span>
              </button>
            </div>
          </div>
        }
        <!-- Sand Report -->
        @if (!isNew && isEditorOrAdmin(user, this.jobToUpdate.companyId || '') && jobToUpdate.workbookType == 'Flowback/Well Testing') {
          <div
            class="field grid col-12">
            <div class="col-2">
              <label>Sand Report</label>
            </div>
            <div class="col-3">
              <p-date-picker [(ngModel)]="sandReportBeginTime" [showIcon]="true" [showTime]="true" [hourFormat]="'24'"
                yearRange="2018:2038">
              </p-date-picker>
            </div>
            <div class="col-3">
              <p-date-picker [(ngModel)]="sandReportEndTime" [showIcon]="true" [showTime]="true" [hourFormat]="'24'"
                yearRange="2018:2038">
              </p-date-picker>
            </div>
            <div class="col-4">
              <button pButton (click)="downloadSandReport()"
                style="max-height:32px; width:100%; padding-top:3px; padding-bottom:5px;">
                <i pButtonIcon class="fa fa-download"></i>
                <span pButtonLabel>Sand Report</span>
              </button>
            </div>
          </div>
        }
        <!-- Data Sheet Report -->
        @if (!isNew && isEditorOrAdmin(user, this.jobToUpdate.companyId || '') && jobToUpdate.workbookType == 'Flowback/Well Testing') {
          <div
            class="field grid col-12">
            <div class="col-2">
              <label>Data Sheet Report</label>
            </div>
            <div class="col-3">
              <p-date-picker [(ngModel)]="dataSheetReportBeginTime" [showIcon]="true" [showTime]="true" [hourFormat]="'24'"
                yearRange="2018:2038">
              </p-date-picker>
            </div>
            <div class="col-3">
              <p-date-picker [(ngModel)]="dataSheetReportEndTime" [showIcon]="true" [showTime]="true" [hourFormat]="'24'"
                yearRange="2018:2038">
              </p-date-picker>
            </div>
            <div class="col-4">
              <button pButton
                (click)="downloadDataSheetReport()"
                style="max-height:32px; width:100%; padding-top:3px; padding-bottom:5px;">
                <i pButtonIcon class="fa fa-download"></i>
                <span pButtonLabel>Data Sheet</span>
              </button>
            </div>
          </div>
        }
      }
      <div class="col-12">
        <app-vendor-job-common [(ngModel)]="jobToUpdate" [modelInvalid]="modelInvalid" [disabled]="disabled"
        [showWorkbookLink]="false"></app-vendor-job-common>
      </div>
      <div class="col-12">
        @if (company$ | async; as company) {
          <p-accordion [multiple]="false"  >
            <p-accordion-panel value="workbookConfig">
              <p-accordion-header>Workbook Configuration</p-accordion-header>
              <p-accordion-content>
                @if ((jobToUpdate.id || routeJobId) && (jobToUpdate.companyId || company.id)) {
                  <app-workbook-configuration [companyId]="jobToUpdate.companyId || company.id || ''" [jobId]="jobToUpdate.id || routeJobId"
                    [jobType]="jobToUpdate.workbookType || ''" [companyUnitSystem]="company.unitSystem || ''"
                    (jobConfiguration)="updateWorkbookConfiguration($event)" (errors)="handleErrorsFromConfiguration($event)">
                  </app-workbook-configuration>
                }
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        }
      </div>
      <!-- Action Buttons -->
      <div class="col-12">
        @if (isNew) {
<button pButton (click)="saveJob()" [disabled]="saving" [ngClass]="{ 'action-button': !saving,
                         'action-button-disabled': saving }">
            Create
          </button>
        }
        @if (!isNew) {
<button pButton (click)="saveJob()" [disabled]="saving || isUserServiceProvider" [ngClass]="{ 'action-button': !saving,
                         'action-button-disabled': saving }">
            Update
          </button>
        }
        <button pButton (click)="returnToJobList()" class="action-button">
          Cancel
        </button>
      </div>
    </div>
  }

  <!--Invalid Model Dialog-->
  <p-dialog header="Cannot Save Changes" [(visible)]="showModelInvalidDialog" [modal]="true" [style]="{width: '350px'}"
    [minY]="70" [baseZIndex]="999" [autoZIndex]="false" [dismissableMask]="true">
    <span>
      One or more fields is empty or invalid. Please correct and try again.
    </span>
    <p-footer>
      <button type="button" pButton (click)="closeInvalidModelDialog()">
        <i pButtonIcon class="pi pi-check"></i>
        <span pButtonLabel>Ok</span>
      </button>
    </p-footer>
  </p-dialog>

  <!-- ContactInfo Dialog -->
  @if (jobToUpdate) {
    <p-dialog header="Company Contact Information" [(visible)]="showCompanyContactInfoDialog">
      <app-contact-info [(ngModel)]="jobToUpdate.consumerCompanyId"></app-contact-info>
    </p-dialog>
  }

  <!-- Files Dialog -->
  @if (showManageFiles) {
    <p-dialog header="Job Files" [(visible)]="showManageFiles">
      <app-filelist [consumerJobId]="jobToUpdate.consumerJobId || ''"></app-filelist>
      <p-footer>
        <button type="button" pButton (click)="showManageFiles = false">
          <i pButtonIcon class="pi pi-check"></i>
          <span pButtonLabel>Close</span>
        </button>
      </p-footer>
    </p-dialog>
  }

  <!-- Device Selection Dialog -->
  <p-dialog header="Select Device" [(visible)]="showDeviceDialog" [modal]="true" [style]="{width: '100vw', maxWidth: '900px'}">
    @if (companyContextDeviceMaps$ | async; as companyContextDeviceMaps) {
      @if (companyContextDeviceMaps.length === 0) {
        <div class="flex flex-column align-items-center justify-content-center p-4">
          <i class="pi pi-info-circle text-6xl text-blue-500 mb-3"></i>
          <h3 class="text-center mb-2">No Devices Available</h3>
          <p class="text-center text-color-secondary">
            There are no devices currently assigned to {{ (companyContext$ | async)?.companyName || 'this company' }}.
          </p>
        </div>
      } @else {
        <p-table #dt
          [value]="filterDevices(companyContextDeviceMaps)"
          [scrollable]="true"
          scrollHeight="400px"
          [globalFilterFields]="['deviceName','type','jobName']"
          [sortField]="'deviceName'"
          [sortOrder]="1"
          [tableStyle]="{'min-width': '50rem'}"
          [filterDelay]="0">
          <ng-template #caption>
            <div class="flex justify-content-between align-items-center">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                  (input)="dt.filterGlobal($event.target.value, 'contains')"
                  placeholder="Search devices..." />
                </span>
                <span>
                  <p-checkbox [(ngModel)]="showOnlyUnassigned"
                    [binary]="true"
                    label="Show only unassigned devices">
                  </p-checkbox>
                </span>
              </div>
            </ng-template>
            <ng-template #header>
              <tr>
                <th pSortableColumn="deviceName">Device Name<p-sortIcon field="deviceName"></p-sortIcon></th>
                <th pSortableColumn="deviceType">Type<p-sortIcon field="deviceType"></p-sortIcon></th>
                <th pSortableColumn="jobName">Current Job<p-sortIcon field="jobName"></p-sortIcon></th>
                <th pSortableColumn="jobStartDate">Job Start<p-sortIcon field="jobStartDate"></p-sortIcon></th>
                <th pSortableColumn="jobEndDate">Job End<p-sortIcon field="jobEndDate"></p-sortIcon></th>
                <th>Action</th>
              </tr>
            </ng-template>
            <ng-template #body let-device>
              <tr>
                <td>{{device.deviceName}}</td>
                <td>{{device.deviceType}}</td>
                <td>{{device.jobName || 'Not Assigned'}}</td>
                <td>{{device.jobStartDate | date:'short'}}</td>
                <td>{{device.jobEndDate | date:'short'}}</td>
                <td>
                  @if (!device.jobId) {
                    <button pButton
                      type="button"
                      class="p-button-sm"
                      [disabled]="jobToUpdate.deviceList?.includes(device.deviceId || '')"
                      (click)="addDevice(device.deviceId || '')">
                      <span pButtonLabel>Assign</span>
                    </button>
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        }
      }
    </p-dialog>
